export default "__VITE_ASSET__CfbmEaIX__"